import { ENDPOINT_BASE_URL } from "../../../configs/config";

const buildQueryString = (params) => {
  const searchParams = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      searchParams.append(key, value);
    }
  });
  const query = searchParams.toString();
  return query ? `?${query}` : "";
};

export const fetchDailyPortfolioData = async (startDate, endDate) => {
  try {
    const query = buildQueryString({
      start_date: startDate,
      end_date: endDate,
    });

    const response = await fetch(
      `${ENDPOINT_BASE_URL}/track_records_daily_latest${query}`
    );

    if (!response.ok) {
      throw new Error("Failed to fetch daily portfolio data");
    }

    const data = await response.json();
    const records = Array.isArray(data?.data) ? data.data : [];

    return {
      datasets1: records.map((record) => record.portfolio_expected_apr),
      datasets2: records.map((record) => record.thirty_day_apy),
      datasets3: records.map((record) => record.ninety_day_apy),
      datasets4: records.map((record) => record.dollar_value_growth),
      labels: records.map((record) => record.timestamp),
    };
  } catch (error) {
    console.error("Error fetching daily portfolio data:", error);
    throw error;
  }
};

export const fetchDailyTotalAssertData = async (date) => {
  try {
    const query = buildQueryString({ date });

    const response = await fetch(
      `${ENDPOINT_BASE_URL}/track_records_daily_latest${query}`
    );

    if (!response.ok) {
      throw new Error("Failed to fetch daily total assets data");
    }

    const data = await response.json();
    const records = Array.isArray(data?.data) ? data.data : [];

    const filterDate = new Date("2024-07-24");
    const filteredData = records.filter(
      (record) => new Date(record.timestamp) > filterDate
    );

    return {
      datasets1: filteredData.map((record) => record.net_exposure_value),
      datasets2: filteredData.map((record) => record.total_assets_value),
      labels: filteredData.map((record) => record.timestamp),
    };
  } catch (error) {
    console.error("Error fetching daily total assets data:", error);
    throw error;
  }
};

export const fetchAdjustedDailyPortfolioData = async (startDate, endDate) => {
  try {
    const query = buildQueryString({
      start_date: startDate,
      end_date: endDate,
    });

    const response = await fetch(
      `${ENDPOINT_BASE_URL}/track_records_daily_latest${query}`
    );

    if (!response.ok) {
      throw new Error("Failed to fetch adjusted daily portfolio data");
    }

    const data = await response.json();
    const records = Array.isArray(data?.data) ? data.data : [];
    const cutoff = Math.max(records.length - 20, 0);

    const dailyDataArray = [];
    const thirtyDayApy = [];
    const ninetyDayApy = [];
    const correspondingDay = [];
    const dollarValueGrowth = [];

    for (let i = 0; i < cutoff; i++) {
      const record = records[i];
      dailyDataArray.push(record.portfolio_implied_apr);
      thirtyDayApy.push(record.thirty_day_apy);
      ninetyDayApy.push(record.ninety_day_apy);
      correspondingDay.push(record.timestamp);
      dollarValueGrowth.push(record.dollar_value_growth);
    }

    dollarValueGrowth.push(1);
    correspondingDay.push("Tue, 22 Jul 2024 23:11:49 GMT");

    return {
      datasets1: dailyDataArray,
      datasets2: thirtyDayApy,
      datasets3: ninetyDayApy,
      datasets4: dollarValueGrowth,
      labels: correspondingDay,
    };
  } catch (error) {
    console.error("Error fetching adjusted daily portfolio data:", error);
    throw error;
  }
};
